// @todo: Remove this file as this polyfill is now redundant

/* eslint-disable */
(function (self) {
  'use strict';

  var nativeURLSearchParams = (
      self.URLSearchParams && typeof self.URLSearchParams.prototype.get === 'function' ? self.URLSearchParams : null
    ) as any,
    isSupportObjectConstructor =
      nativeURLSearchParams && new nativeURLSearchParams({ a: 1 } as any).toString() === 'a=1',
    // There is a bug in safari 10.1 (and earlier) that incorrectly decodes `%2B` as an empty space and not a plus.
    decodesPlusesCorrectly = nativeURLSearchParams && new nativeURLSearchParams('s=%2B').get('s') === '+',
    __URLSearchParams__ = '__URLSearchParams__',
    // Fix bug in Edge which cannot encode ' &' correctly
    encodesAmpersandsCorrectly = nativeURLSearchParams
      ? (function () {
          var ampersandTest = new nativeURLSearchParams();
          ampersandTest.append('s', ' &');
          return ampersandTest.toString() === 's=+%26';
        })()
      : true,
    prototype = URLSearchParamsPolyfill.prototype,
    iterable = !!(self.Symbol && self.Symbol.iterator);

  if (nativeURLSearchParams && isSupportObjectConstructor && decodesPlusesCorrectly && encodesAmpersandsCorrectly) {
    return;
  }

  /**
   * Make a URLSearchParams instance
   *
   * @param {object|string|URLSearchParams} search
   * @constructor
   */
  function URLSearchParamsPolyfill(this: any, search: any) {
    search = search || '';

    // support construct object with another URLSearchParams instance
    if (search instanceof URLSearchParams || search instanceof URLSearchParamsPolyfill) {
      search = search.toString();
    }
    this[__URLSearchParams__] = parseToDict(search);
  }

  /**
   * Appends a specified key/value pair as a new search parameter.
   *
   * @param {string} name
   * @param {string} value
   */
  prototype.append = function (name: any, value: any) {
    appendTo(this[__URLSearchParams__], name, value);
  };

  /**
   * Deletes the given search parameter, and its associated value,
   * from the list of all search parameters.
   *
   * @param {string} name
   */
  prototype['delete'] = function (name: any) {
    delete this[__URLSearchParams__][name];
  };

  /**
   * Returns the first value associated to the given search parameter.
   *
   * @param {string} name
   * @returns {string|null}
   */
  prototype.get = function (name: any) {
    var dict = this[__URLSearchParams__];
    return name in dict ? dict[name][0] : null;
  };

  /**
   * Returns all the values association with a given search parameter.
   *
   * @param {string} name
   * @returns {Array}
   */
  prototype.getAll = function (name: any) {
    var dict = this[__URLSearchParams__];
    return name in dict ? dict[name].slice(0) : [];
  };

  /**
   * Returns a Boolean indicating if such a search parameter exists.
   *
   * @param {string} name
   * @returns {boolean}
   */
  prototype.has = function (name: any) {
    return name in this[__URLSearchParams__];
  };

  /**
   * Sets the value associated to a given search parameter to
   * the given value. If there were several values, delete the
   * others.
   *
   * @param {string} name
   * @param {string} value
   */
  prototype.set = function set(name: any, value: any) {
    this[__URLSearchParams__][name] = ['' + value];
  };

  /**
   * Returns a string containg a query string suitable for use in a URL.
   *
   * @returns {string}
   */
  prototype.toString = function () {
    var dict = this[__URLSearchParams__],
      query = [],
      i,
      key,
      name,
      value;
    for (key in dict) {
      name = encode(key);
      for (i = 0, value = dict[key]; i < value.length; i++) {
        query.push(name + '=' + encode(value[i]));
      }
    }
    return query.join('&');
  };

  // There is a bug in Safari 10.1 and `Proxy`ing it is not enough.
  var forSureUsePolyfill = !decodesPlusesCorrectly;
  var useProxy = !forSureUsePolyfill && nativeURLSearchParams && !isSupportObjectConstructor && self.Proxy;
  /*
   * Apply polifill to global object and append other prototype into it
   */
  Object.defineProperty(self, 'URLSearchParams', {
    value: useProxy
      ? // Safari 10.0 doesn't support Proxy, so it won't extend URLSearchParams on safari 10.0
        new Proxy(nativeURLSearchParams as any, {
          construct: function (target: any, args: any) {
            return new (target as new (...args: any[]) => any)(
              new (URLSearchParamsPolyfill as any)(args[0]).toString()
            );
          },
        })
      : URLSearchParamsPolyfill,
  });

  var USPProto = self.URLSearchParams.prototype;

  (USPProto as any).polyfill = true;

  /**
   *
   * @param {function} callback
   * @param {object} thisArg
   */
  USPProto.forEach =
    USPProto.forEach ||
    function (this: any, callback, thisArg) {
      var dict = parseToDict(this.toString()) as Record<string, any[]>;
      Object.getOwnPropertyNames(dict).forEach(function (this: any, name) {
        dict[name].forEach(function (this: any, value: any) {
          callback.call(thisArg, value, name, this);
        }, this);
      }, this);
    };

  /**
   * Sort all name-value pairs
   */
  USPProto.sort =
    USPProto.sort ||
    function (this: any) {
      var dict = parseToDict(this.toString()) as Record<string, any[]>,
        keys = [],
        k,
        i,
        j;
      for (k in dict) {
        keys.push(k);
      }
      keys.sort();

      for (i = 0; i < keys.length; i++) {
        this['delete'](keys[i]);
      }
      for (i = 0; i < keys.length; i++) {
        var key = keys[i],
          values = dict[key];
        for (j = 0; j < values.length; j++) {
          this.append(key, values[j]);
        }
      }
    };

  /**
   * Returns an iterator allowing to go through all keys of
   * the key/value pairs contained in this object.
   *
   * @returns {function}
   */
  USPProto.keys =
    USPProto.keys ||
    function (this: any) {
      var items: any = [];
      this.forEach(function (_item: any, name: any) {
        items.push(name);
      });
      return makeIterator(items);
    };

  /**
   * Returns an iterator allowing to go through all values of
   * the key/value pairs contained in this object.
   *
   * @returns {function}
   */
  USPProto.values =
    USPProto.values ||
    function (this: any) {
      var items: any = [];
      this.forEach(function (item: any) {
        items.push(item);
      });
      return makeIterator(items);
    };

  /**
   * Returns an iterator allowing to go through all key/value
   * pairs contained in this object.
   *
   * @returns {function}
   */
  USPProto.entries =
    USPProto.entries ||
    function (this: any) {
      var items: any = [];
      this.forEach(function (item: any, name: any) {
        items.push([name, item]);
      });
      return makeIterator(items);
    };

  if (iterable) {
    USPProto[self.Symbol.iterator] = USPProto[self.Symbol.iterator] || USPProto.entries;
  }

  function encode(str: any) {
    var replace: Record<string, string> = {
      '!': '%21',
      "'": '%27',
      '(': '%28',
      ')': '%29',
      '~': '%7E',
      '%20': '+',
      '%00': '\x00',
    };
    return encodeURIComponent(str).replace(/[!'\(\)~]|%20|%00/g, function (match) {
      return replace[match];
    });
  }

  function decode(str: any) {
    return str.replace(/[ +]/g, '%20').replace(/(%[a-f0-9]{2})+/gi, function (match: any) {
      return decodeURIComponent(match);
    });
  }

  function makeIterator(arr: any) {
    var iterator = {
      next: function () {
        var value = arr.shift();
        return { done: value === undefined, value: value };
      },
    };

    if (iterable) {
      (iterator as any)[self.Symbol.iterator] = function () {
        return iterator;
      };
    }

    return iterator;
  }

  function parseToDict(search: any) {
    var dict = {};

    if (typeof search === 'object') {
      for (var key in search) {
        if (search.hasOwnProperty(key)) {
          appendTo(dict, key, search[key]);
        }
      }
    } else {
      // remove first '?'
      if (search.indexOf('?') === 0) {
        search = search.slice(1);
      }

      var pairs = search.split('&');
      for (var j = 0; j < pairs.length; j++) {
        var value = pairs[j],
          index = value.indexOf('=');

        if (-1 < index) {
          appendTo(dict, decode(value.slice(0, index)), decode(value.slice(index + 1)));
        } else {
          if (value) {
            appendTo(dict, decode(value), '');
          }
        }
      }
    }

    return dict;
  }

  function appendTo(dict: any, name: any, value: any) {
    var val =
      typeof value === 'string'
        ? value
        : value !== null && value !== undefined && typeof value.toString === 'function'
          ? value.toString()
          : JSON.stringify(value);

    if (name in dict) {
      dict[name].push(val);
    } else {
      dict[name] = [val];
    }
  }
})(typeof global !== 'undefined' ? global : typeof window !== 'undefined' ? window : this);
